import { catalogWithCompanyValues } from "./integrationsCatalog";
import { useTranslation } from "react-i18next";

export default function ServicesTab({ company, onOpen }) {
  const { t } = useTranslation();
  const items = catalogWithCompanyValues(company);

  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-3">
      {items.map((item) => {
        const Icon = item.icon;
        return (
          <button
            key={item.key}
            type="button"
            onClick={() => onOpen(item)}
            className="rounded-[18px] border border-slate-200 bg-white p-5 text-left shadow-[0_1px_2px_rgba(0,0,0,.04),0_6px_22px_rgba(0,0,0,.07)] transition hover:border-[#BFDCF7]"
          >
            <div className="flex items-start justify-between gap-3">
              <div className="flex h-11 w-11 items-center justify-center rounded-2xl bg-[#EAF3FD] text-[#1463C7]">
                <Icon className="h-6 w-6" />
              </div>
              <span
                className={`inline-flex items-center rounded-full px-2.5 py-1 text-xs font-semibold ${
                  item.connected ? "bg-emerald-50 text-emerald-800" : "bg-amber-50 text-amber-800"
                }`}
              >
                {item.connected
                  ? t("company.integrations.status.connected")
                  : t("company.integrations.status.missing")}
              </span>
            </div>
            <h3 className="mt-4 text-base font-extrabold text-slate-950">
              {t(`company.integrations.${item.key}.title`)}
            </h3>
            <p className="mt-1 text-sm text-slate-500">
              {t(`company.integrations.${item.key}.description`)}
            </p>
          </button>
        );
      })}
    </div>
  );
}
